import React from "react";
import toast from "react-hot-toast";
import { getManualQRIS, updateManualQRIS } from "api/ManualQRISAPI";
import { FieldValues, SubmitHandler } from "react-hook-form";

const useManualQRIS = () => {
  const [QRISImageUrl, setQRISImageUrl] = React.useState<string>("");
  const [images, setImage] = React.useState<File[] | []>([]);

  const getManualQRISData = async () => {
    try {
      const response = await getManualQRIS();
      setQRISImageUrl(response.data.data.image);
    } catch (error) {
      toast.error("Gagal mengambil data QRIS");
    }
  };

  const onUpdate = async (image: File) => {
    const promise = updateManualQRIS(image);

    toast.promise(promise, {
      loading: "Memperbarui QRIS Manual...",
      success: () => {
        getManualQRISData();
        window.location.reload();
        return "Berhasil memperbarui QRIS Manual";
      },
      error: "Gagal memperbarui QRIS Manual",
    });
  };

  const handleUpdate: SubmitHandler<FieldValues> = (data) => {
    if (images.length === 0) {
      toast.error("Harap pilih file QRIS terlebih dahulu");
      return;
    }

    onUpdate(images[0]);
  };

  const dropFile = (files: File[]) => setImage(files);
  const removeFile = (files: File[]) => setImage([]);
  const arrangeFiles = (files: File[]) => setImage(files);
  const changeFile = (files: File[]) => setImage(files);

  return {
    getManualQRISData,
    onUpdate,
    QRISImageUrl,
    images,
    dropFile,
    removeFile,
    arrangeFiles,
    changeFile,
    handleUpdate,
  };
};

export default useManualQRIS;
